<template>
  <div class="big">
    <div class="container">
      <div class="searchbox">
        <el-button
          type="primary"
          style="width: 120px; margin-right: 15px"
          icon="el-icon-plus"
          @click="AddDoctor"
          :disabled="
            module_id_array[0] ? !module_id_array.includes('22') : false
          "
          >添加医生</el-button
        >
        <span>医生名称</span>
        <el-input
          v-model="doctorName"
          style="width: 130px; margin: 0 10px"
          clearable
          @change="search"
        ></el-input>
        <span>手机号</span>
        <el-input
          v-model="doctorPhone"
          style="width: 130px; margin: 0 10px"
          clearable
          @change="search"
        ></el-input>
        <span>所在省市</span>
        <el-select
          v-model="province_id"
          placeholder="请选择"
          @change="search"
          style="width: 140px; margin: 0 10px"
          clearable
        >
          <el-option
            v-for="item in proList"
            :key="item.province_id"
            :label="item.name"
            :value="item.province_id"
          ></el-option>
        </el-select>
        <span>来源</span>
        <el-select
          v-model="doc_from"
          placeholder="请选择"
          style="width: 130px; margin: 0 20px 0 10px"
          @change="search"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button
          type="info"
          style="background-color: #eceff2; color: #747981"
          @click="search"
          >查询</el-button
        >
        <span style="margin: 0 10px 0 15px">是否测试</span>
        <el-radio-group v-model="is_test" @change="search">
          <el-radio :label="0">全部</el-radio>
          <el-radio :label="1">是</el-radio>
          <el-radio :label="2">否</el-radio>
        </el-radio-group>
      </div>
      <div style="border: solid 1px #c9cbd6">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%; min-width: 1000px"
          :header-cell-style="{ background: '#F5F5F5' }"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-background="rgba(0, 0, 0,0.1)"
        >
          <el-table-column prop="user_name" label="医生头像">
            <template slot-scope="scope">
              <div
                v-if="scope.row.head_img"
                style="border: solid 1px #d3d3d3; width: 42px; height: 42px"
              >
                <img
                  :src="scope.row.head_img"
                  alt
                  style="width: 40px; height: 40px"
                />
              </div>
              <div class="headimg" v-else></div>
            </template>
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="注册时间"
          ></el-table-column>
          <el-table-column prop="doctor_name" label="医生姓名">
            <template slot-scope="scope">
              <div>
                <span>{{ scope.row.doctor_name }}</span>
                <span v-if="scope.row.sex == 1" style="margin-left: 16px"
                  >男</span
                >
                <span v-if="scope.row.sex == 2" style="margin-left: 16px"
                  >女</span
                >
              </div>
              <div>{{ scope.row.phone }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="province_name"
            label="所在省市"
          ></el-table-column>
          <el-table-column label="认证申请单">
            <template slot-scope="scope">
              <div
                v-if="scope.row.auth_count"
                style="color: #669961; cursor: pointer"
                @click="toshenhelist(scope.row)"
              >
                {{ scope.row.auth_count }}
              </div>
              <div v-else style="color: #669961">
                {{ scope.row.auth_count }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="最新审核状态">
            <template slot-scope="scope">
              <span v-if="scope.row.verify_status == 2" style="color: #669961"
                >审核中</span
              >
              <span v-if="scope.row.verify_status == 4" style="color: #d0523c"
                >审核不通过</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="hospital" label="医院名称"></el-table-column>
          <el-table-column
            prop="department_name"
            label="科室"
          ></el-table-column>
          <el-table-column label="来源">
            <template slot-scope="scope">
              <span v-if="scope.row.doc_from == 1">APP注册</span>
              <span v-if="scope.row.doc_from == 2">平台添加</span>
              <span v-if="scope.row.doc_from == 3">邀请注册</span>
              <span v-if="scope.row.doc_from == 4">接口同步</span>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="260">
            <template slot-scope="scope">
              <el-button
                @click="shenQing(scope.row)"
                type="text"
                v-if="
                  scope.row.verify_status == 0 || scope.row.verify_status == 1
                "
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('25') : false
                "
                >申请认证</el-button
              >
              <el-button
                @click="shenQing(scope.row)"
                type="text"
                v-if="scope.row.verify_status == 4"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('25') : false
                "
                >重新认证</el-button
              >
              <el-button
                @click="
                  editdialog(
                    scope.row.doctor_name_str,
                    scope.row.sex,
                    scope.row.doctor_id
                  )
                "
                type="text"
                v-if="
                  scope.row.verify_status == 4 ||
                  scope.row.verify_status == 0 ||
                  scope.row.verify_status == 1
                "
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('192') : false
                "
                >修改</el-button
              >
              <el-button
                @click="cancelDoctor(scope.row.doctor_id)"
                type="text"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('924') : false
                "
                >注销</el-button
              >
              <el-button
                @click="toDetail(scope.row.doctor_id)"
                type="text"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1274') : false
                "
                >详情</el-button
              >
              <span
                style="margin-left: 10px; color: #669961"
                v-if="
                  module_id_array[0] ? module_id_array.includes('186') : true
                "
              >
                测试
                <el-switch
                  v-model="scope.row.is_test"
                  active-color="#669961"
                  @change="
                    (value) => {
                      return setTest(value, scope.row.doctor_id);
                    }
                  "
                ></el-switch>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          style="margin: 20px 0"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="添加医生"
      :visible.sync="add_doctor"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="myform nomargin">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
        >
          <el-form-item label="医生姓名" prop="doctor_name">
            <el-input
              v-model="ruleForm.doctor_name"
              maxlength="20"
              style="width: 420px"
            ></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="doctor_sex">
            <div style="text-align: left">
              <el-radio v-model="ruleForm.doctor_sex" :label="1">男</el-radio>
              <el-radio v-model="ruleForm.doctor_sex" :label="2">女</el-radio>
            </div>
          </el-form-item>
          <el-form-item label="手机号" prop="doctor_phone">
            <el-input
              v-model="ruleForm.doctor_phone"
              style="width: 220px"
            ></el-input>
          </el-form-item>
          <el-form-item label="邀请码">
            <el-input
              v-model="ruleForm.recommender_code"
              style="width: 220px"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div
        style="height: 1px; background-color: #d9dadd; margin-bottom: 14px"
      ></div>
      <div style="text-align: center; padding-bottom: 20px">
        <span slot="footer" class="dialog-footer">
          <el-button
            plain
            @click="add_doctor = false"
            style="width: 92px"
            size="medium"
            >关闭</el-button
          >
          <el-button
            type="primary"
            @click="submit('ruleForm')"
            style="width: 92px"
            size="medium"
            >保存</el-button
          >
        </span>
      </div>
    </el-dialog>
    <el-dialog
      title="修改姓名/性别"
      :visible.sync="edit_doctor"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="myform nomargin">
        <el-form
          :model="eidtForm"
          :rules="edit_rules"
          ref="eidtForm"
          label-width="120px"
          class="demo-ruleForm"
        >
          <el-form-item label="医生姓名" prop="doctor_name">
            <el-input
              v-model="eidtForm.doctor_name"
              maxlength="6"
              style="width: 220px"
            ></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="doctor_sex">
            <div style="text-align: left">
              <el-radio v-model="eidtForm.doctor_sex" :label="1">男</el-radio>
              <el-radio v-model="eidtForm.doctor_sex" :label="2">女</el-radio>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div
        style="height: 1px; background-color: #d9dadd; margin-bottom: 14px"
      ></div>
      <div style="text-align: center; padding-bottom: 20px">
        <span slot="footer" class="dialog-footer">
          <el-button
            plain
            @click="edit_doctor = false"
            style="width: 92px"
            size="medium"
            >关闭</el-button
          >
          <el-button
            type="primary"
            @click="edit('eidtForm')"
            style="width: 92px"
            size="medium"
            >保存</el-button
          >
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import doctor from "../../../api/doctor";
import platform from "../../../api/platform";
import _ from "lodash";

export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      loading: true,
      doctorName: "",
      doctorPhone: "",
      is_test: 2,
      doc_from: 0,
      add_doctor: false,
      edit_doctor: false,
      province_id: "",
      proList: [],
      options: [
        {
          value: 0,
          label: "全部",
        },
        {
          value: 1,
          label: "APP注册",
        },
        {
          value: 2,
          label: "平台添加",
        },
        {
          value: 3,
          label: "邀请注册",
        },
        {
          value: 4,
          label: "接口同步",
        },
      ],
      ruleForm: {
        doctor_name: "",
        doctor_sex: "",
        doctor_phone: "",
        recommender_code: "",
      },
      rules: {
        doctor_name: [
          {
            required: true,
            message: "请输入医生姓名",
            trigger: "blur",
          },
          { max: 20, message: '请输入20位以内的字符', trigger: 'blur' },
          // {
          //   pattern: /^[\u4e00-\u9fa5]{0,}$/,
          //   message: "请输入6位以内汉字",
          //   trigger: ["blur", "change"],
          // },
        ],
        doctor_sex: [
          { required: true, message: "请选择性别", trigger: "blur" },
        ],
        doctor_phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^(1[3456789])\d{9}$/,
            message: "请输入正确手机号",
            trigger: "blur",
          },
        ],
      },
      eidtForm: {
        doctor_name: "",
        doctor_sex: "",
        doctor_id: "",
      },
      edit_rules: {
        doctor_name: [
          {
            required: true,
            message: "请输入医生姓名",
            trigger: "blur",
          },
          { max: 6, message: "请输入6位以内汉字", trigger: "blur" },
          {
            pattern: /^[\u4e00-\u9fa5]{0,}$/,
            message: "请输入6位以内汉字",
            trigger: ["blur", "change"],
          },
        ],
        doctor_sex: [
          { required: true, message: "请选择性别", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    },
  },
  methods: {
    //获取省市列表
    getProvince() {
      this.axios
        .post("platform/platform/getProvinceCityDistrict")
        .then((res) => {
          this.proList = res.data.list;
        });
    },
    //获取医生列表
    getList() {
      this.loading = true;
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        auth_status: 1,
        doctor_name: this.doctorName,
        doctor_phone: this.doctorPhone,
        doc_from: this.doc_from,
        province_id: this.province_id,
        is_test: this.is_test,
      };
      doctor
        .doctorList(data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.create_time = platform.timestampToTime(item.create_time);
              item.is_test = item.is_test == 1 ? true : false;
              return item;
            });
            this.totalNum = res.data.total;
            this.loading = false;
          } else {
            this.$message.error(res.message);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //添加医生按钮
    AddDoctor() {
      this.ruleForm = {
        doctor_name: "",
        doctor_sex: "",
        doctor_phone: "",
      };
      this.add_doctor = true;
    },
    //添加医生
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let addData = this.ruleForm;
          doctor
            .addDoctor(addData)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success(
                  "保存成功！登录密码已发送短信到手机。手机密码随机生成，由8位字母和数字组合。"
                );
                this.add_doctor = false;
                this.getList();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //设置测试账号
    setTest(value, doctor_id) {
      let text = "";
      let status = "";
      if (value) {
        text = "确定将该账号设置为测试账号？";
        status = 1;
      } else {
        text = "确定取消测试账号？";
        status = 2;
      }

      this.$confirm(text, "提示消息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          doctor.setTestDoctor({ doctor_id, status }).then((res) => {
            if (res.code == 0) {
              this.$message.success("设置成功");
              this.getList();
            } else {
              this.getList();
            }
          });
        })
        .catch(() => {
          this.getList();
        });
    },
    //申请认证
    shenQing(row) {
      this.$router.push({
        path: "shenqing",
        query: {
          doctor_id: row.doctor_id,
          doctor_name: row.doctor_name_str,
          sex: row.sex == 1 ? "男" : "女",
          phone: row.phone,
          reviewed_id: row.reviewed_id,
        },
      });
    },

    //点击申请单去审核列表
    toshenhelist(row) {
      this.$router.push({
        name: "shenhelist",
        params: {
          doctor_name: row.doctor_name,
          phone: row.phone,
        },
      });
    },
    //修改医生名字弹窗
    editdialog(doctor_name_str, sex, doctor_id) {
      this.eidtForm.doctor_name = doctor_name_str;
      this.eidtForm.doctor_sex = sex;
      this.eidtForm.doctor_id = doctor_id;
      this.edit_doctor = true;
    },
    //修改医生信息
    edit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.eidtForm;
          doctor.modify(data).then((res) => {
            if (res.code == 0) {
              this.$message.success("修改成功！");
              this.edit_doctor = false;
              this.getList();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //注销医生
    cancelDoctor(doctor_id) {
      this.$confirm("确定注销该医生吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.axios
            .post("platform/doctor/cancelDoctorAccount", { doctor_id })
            .then((res) => {
              this.$message.success("该医生账号已注销");
              this.getList();
            });
        })
        .catch(() => {});
    },
    //医生详情
    toDetail(doctor_id) {
      this.$router.push({
        path: "weirenzhengdetail",
        query: { doctor_id },
      });
    },
  },
  created() {
    this.getProvince();
  },
  activated() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 210px);
}
.searchbox {
  display: flex;
  margin-bottom: 20px;
  align-items: center;
}
.searh_icon {
  width: 50px;
  height: 38px;
  line-height: 38px;
  background: #ececec;
  position: absolute;
  font-size: 18px;
  right: 1px;
  top: 1px;
  cursor: pointer;
  color: #747e81;
}
.myform {
  width: 300px;
  padding-top: 20px;
  margin-bottom: 20px;
}
.headimg {
  width: 40px;
  height: 40px;
  background: #d8d8d8;
}
</style>
